import { useMemo } from 'react';
import { marketIntelligenceApi } from '../../../Apis/Apis';
import applicationSettings from '../../../Core/Settings/ApplicationSettings';
import { ArticleModel } from '../../../Generated/Raven/api';
import useApi from './useApiHook';

// Defaults.
const defaultSearchTerm = undefined;
const defaultAuthor = undefined;
const defaultIsExactSearch = undefined;
const defaultDateRangeStart = undefined;
const defaultDateRangeEnd = undefined;
const defaultMarketId = undefined;
const defaultContentConfigurationId = undefined;
const defaultLanguageCode = undefined;
const defaultUsePremiumTrial = false;
const defaultSubscriptionCountry = undefined;
const defaultMobileApplication = undefined;
const defaultSource = applicationSettings.applicationName;
const defaultShowOnlySubscibedArticles = false;
const defaultTake = 1000;
const defaultSkip = 0;

const useMarketIntelligenceArticlesApi = (): [isLoading: boolean, articles: ArticleModel[]] => {
    const [isLoading, , listArticlesResponse] = useApi(() =>
        marketIntelligenceApi.listArticles(
            defaultSearchTerm,
            defaultAuthor,
            defaultIsExactSearch,
            defaultDateRangeStart,
            defaultDateRangeEnd,
            defaultMarketId,
            defaultContentConfigurationId,
            defaultLanguageCode,
            defaultUsePremiumTrial,
            defaultSubscriptionCountry,
            defaultMobileApplication,
            defaultSource,
            defaultShowOnlySubscibedArticles,
            defaultTake,
            defaultSkip,
        ),
    );

    const articles = useMemo(() => listArticlesResponse?.rows ?? [], [listArticlesResponse]);

    return [isLoading, articles];
};

export default useMarketIntelligenceArticlesApi;
